var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "patsnap-biz-image_preview_dialog image-preview-dialog ai-common-ImagePreviewDialog",
    },
    [
      _c("div", { staticClass: "image-preview-main-area" }, [
        _c("div", { staticClass: "image-preview-dialog-content" }, [
          _c("img", {
            ref: "image",
            staticClass: "patent-image",
            attrs: { src: _vm.imageUrl },
          }),
        ]),
        _c(
          "div",
          { staticClass: "image-preview-arrow image-preview-left-arrow" },
          [
            _c("PtIcon", {
              staticStyle: { "font-size": "14px" },
              attrs: { icon: "SolidArrowLeft" },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "image-preview-arrow image-preview-right-arrow" },
          [
            _c("PtIcon", {
              staticStyle: { "font-size": "14px" },
              attrs: { icon: "SolidArrowRight" },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "image-preview-title" }, [
        _vm._v(" " + _vm._s(_vm.imageTitle) + " "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }